module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020-desktop/0119.jpg?v=263c1907";